import { render, staticRenderFns } from "./MediaCopy.vue?vue&type=template&id=6161dd88&scoped=true&"
import script from "./MediaCopy.vue?vue&type=script&lang=js&"
export * from "./MediaCopy.vue?vue&type=script&lang=js&"
import style0 from "./MediaCopy.vue?vue&type=style&index=0&id=6161dd88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6161dd88",
  null
  
)

export default component.exports